<template>
	<div class="context-topic" :class="componentClass" :id="'task-'+item.auth">

		<div class="context-topic__item" :class="itemClass">

			<div class="context-topic__slide" :style="slideStyle" :class="slideClass"
				 @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
				<div class="context-topic__slide-content">

					<div v-if="typeof index !== 'undefined' && isMD" class="context-topic__checker">

						<div class="context-topic__index caption grey--text">
							{{ indexText }}
						</div>

						<v-btn v-if="hasFullAccessToTask(item)" icon class="icon --check"
							   :class="{'--visible':isTaskDone(item)}"
							   :small="compact"
							   @click.stop.prevent="toggleTaskDone(item)">
							<v-icon :small="compact">mdi-check</v-icon>
						</v-btn>

					</div>

					<btn-prio :item="item"
							  :small="compact"/>

					<div class="context-topic__line" @mousedown="onMouseDownOnItem" @click="onClickItem">
						<div class="context-topic__selector"
							 @mousedown="onMouseDownOnItem" @click="onClickItem">

							<v-icon v-if="item.bellTill" :small="compact"
									class="icon --bell mr-2 flex-shrink-0 warning--text"
									title="Из шаблона">mdi-bell-outline
							</v-icon>
							<!--				<template v-if="!plain && item.hasChildren">
												<v-icon class="icon &#45;&#45;with-children mr-2 flex-shrink-0">mdi-arrow-right-bottom</v-icon>
											</template>-->

							<v-chip v-if="item.isDelayed" class="mr-2 flex-shrink-0"
									title="Задача отложена"
									:small="!compact"
									:x-small="compact"
									@click.stop.prevent="onClickDelayed">
								<v-icon small>mdi-pause</v-icon>
							</v-chip>
							<v-chip v-else-if="item.delayedTill" class="mr-2 flex-shrink-0"
									:title="'Задача отложена до '+delayedTillFull"
									:small="!compact"
									:x-small="compact"
									@click.stop.prevent="onClickDelayed">{{
									delayedTill
								}}
							</v-chip>

							<v-chip v-if="item.isTemplate" small class="mr-2 flex-shrink-0"
									:color="isTaskTemplateActive(item)?COLOR_TASK_TEMPLATE:COLOR_TASK_TEMPLATE_STOPPED"
									dark
									:title="repeatTitle"
									@click.stop.prevent="onClickTemplate">
								<v-icon small
										title="Это шаблон"
										@click.stop.prevent="onClickTemplate">mdi-view-grid-plus-outline
								</v-icon>
								<span v-if="repeatText" class="ml-2">{{
										repeatText
									}}</span>
							</v-chip>

							<!--					<v-chip v-if="tagsText" small class="mr-2 flex-shrink-0 pointer __tags" dark>
													<v-icon x-small class="mr-1">mdi-pound</v-icon>
													<span>{{ tagsText }}</span>
												</v-chip>-->

							<div v-if="!!image" class="context-topic__thumb">
								<v-img :src="image.srcThumb" :lazy-src="image.srcLazy"/>
							</div>

							<div>
								<div v-if="withNavPath"
									 class="context-topic__navpath caption text-overflow grey--text text--lighten-1">
									<v-icon x-small class="mr-2" color="grey">mdi-folder-outline</v-icon>
									<span v-if="withGroupName">{{ groupOfItem.name }}</span>
									<!--							<router-link v-if="groupOfItem" :to="{name: 'group', params:{groupAuth:groupOfItem.auth}}">
																	<v-icon x-small class="ml-2">mdi-arrow-right</v-icon>
																</router-link>-->
									<template v-if="topicOfItem">
										<span v-if="groupOfItem && withGroupName" class="mx-2">/</span>
										<span>{{ topicOfItem.name }}</span>
										<!--								<router-link v-if="groupOfItem" :to="{name: 'group', params:{groupAuth:groupOfItem.auth}}">
																			<v-icon x-small class="ml-2">mdi-arrow-right</v-icon>
																		</router-link>-->
									</template>
								</div>
								<div v-html="nameHtml" class="context-topic__name"
									 :class="{caption:compact}"></div>
								<div v-if="taskTags?.length"
									 class="context-topic__content caption text-overflow">
							<span v-for="(tag, index) of taskTags" :key="'tag'+index" class="mr-1 __tag"
								  :style="styleOfTag(tag)">
	<!--								<v-icon x-small>mdi-pound</v-icon>-->
									<span>#{{ tag.name }}</span>
								</span>
									<!--							<span v-html="contentHtml" class="__preview grey&#45;&#45;text text&#45;&#45;lighten-1"></span>-->
								</div>
							</div>
						</div>

						<div class="context-topic__tools">
							<!--				<v-icon class="icon &#45;&#45;visible &#45;&#45;passive" :color="item.doneAt?'green':'blue'" title="Есть связанные сообщения">mdi-message-check-outline</v-icon>-->
							<deadline v-if="!compact" :item="item" :disabled="disabled"/>
							<assignee v-if="!compact" :item="item" :disabled="disabled" class="d-none d-md-flex"/>
							<task-menu-btn v-if="!readonly" :item="item" :small="compact"/>
						</div>
					</div>

				</div>

				<div v-if="hasChildren" class="context-topic__progress grey--text" :title="progressTitle"
					 @click="onToggleChildren">
					<v-icon small color="grey">{{ progressIcon }}</v-icon>
					<!--					<v-progress-linear :value="progress" color="success"/>-->
					<div class="caption">{{ childrenText }}</div>
				</div>
			</div>

			<template v-if="!isMD">
				<div class="context-topic__swiped-tools --left">
					<v-icon color="white">mdi-check</v-icon>
				</div>
				<div class="context-topic__swiped-tools --right">
					<v-icon color="white">mdi-pause</v-icon>
				</div>
			</template>

			<mutation :mutation="$store.state.ui.mutations.task" :subject="item"/>
		</div>

		<div v-if="hasChildren && isOpen" class="context-topic__children">
			<context-tasks :items="children" :parent-index="index"/>
		</div>
		<!--		<context-topic-children v-if="withSubtasks" :item="item" class="context-topic__children"/>-->
	</div>
</template>

<script>
import Vue from "vue";
import Deadline from '@/components/elements/deadline';
import Assignee from "@/components/elements/assignee";
import TaskMenuBtn from "@/components/task/task-menu-btn";
import Mutation from "@/components/elements/mutation";
import {date2Iso, iso2DDMMYYYY, mysql2Date, mysql2DDMMYYYY} from "@/utils/date";
import Config from "@/config";
import vp from "@/mixins/vp";
import base from "@/mixins/base";
import {findPs} from "@/utils/p";
import striptags from "striptags";
import {end, maxWords} from "@/utils/string";
import {nick} from "@/utils/user";
import {
	TABS,
	tagsFromText,
	clearName,
	tasksOfContext,
	countContextTasks,
	countContextInactiveTasks
} from "@/utils/task";
import {obtainRootContext} from "@/utils/context";
import BtnPrio from "@/components/btns/btn-prio";
import {PRESETS} from "@/utils/pick";

const SLIDE_THRESHOLD = 5;
const SLIDE_DONE = 60;
const SLIDE_ACTION_CONFIRMATION_TIME = 0;

export default {
	name: "context-topic",
	mixins: [vp, base],
	components: {Assignee, Deadline, TaskMenuBtn, Mutation, BtnPrio},
	props: {
		parentIndex: {},
		item: {},
		index: {},
		withSubtasks: {
			type: Boolean,
			default: false
		},
		withGroupName: {
			type: Boolean,
			default: false
		},
		withTopicName: {
			type: Boolean,
			default: false
		},
		plain: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data: () => ({
		touchStartEvent: null,
		willSetDoneAtTouchEndEvent: null,
		willSetDelayAtTouchEndEvent: null,
		willBeUndone: false,
		slidedX: 0,
		timeOfSlideAction: null,
		isOpen: false,
	}),
	computed: {
		indexText() {
			const texts = [];
			if (this.parentIndex != null) texts.push(this.parentIndex + 1);
			texts.push(this.index + 1);
			return texts.join(".");
		},
		isSelected() {
			return !!this.selectedTasks?.find(el => el.id === this.item.id);
		},
		isLink() {
			return !(this.disabled || this.hasChildren);
		},
		withNavPath() {
			return false;
			//return (this.withGroupName || (this.withTopicName && this.topicOfItem)) && !this.compact;
		},
		groupOfItem() {
			return this.groupOfTask(this.item);
		},
		topicOfItem() {
			return this.topicOfTask(this.item);
		},
		assigneeOfItem() {
			return this.area.users?.find(el => el.id === this.item.userId);
		},
		taskTags() {
			if (!this.item.tagIds) return null;
			//console.log("tagIds", this.item.tagIds?.length);
			//console.log("this.tags", this.tags);
			return this.tags.filter(el => this.item.tagIds.includes(el.id));
		},
		tagsFromText() {
			return tagsFromText(this.item.name);
		},
		tagsText() {
			let text = this.tags?.slice(0, 3).sort().join(", ");
			if (this.tags?.length > 3) text += "...";
			return text;
		},
		componentClass() {
			const c = [];
			return c.length ? c : null;
		},
		itemClass() {
			const c = [];
			if (!this.hasFullAccessToTask(this.item)) c.push("--readonly");
			if (this.compact) c.push("--compact");
			if (this.isSelected && !this.hasChildren) c.push("--selected");

			const rootContext = obtainRootContext();
			if (this.tab !== TABS.ACTUAL || this.compact || rootContext?.withoutTabs) c.push("--ignore-inactivity");

			const topic = this.topicOfTask(this.item);
			if (topic?.isBlock && this.isTopicDone(topic)) c.push("--done");
			else if ((this.isTaskDone(this.item) || this.willSetDoneAtTouchEndEvent) && !this.willBeUndone) c.push("--done");
			else if (this.isTaskDelayed(this.item)) c.push("--weak");
			else if (this.item.isNote) c.push("--weak");
			else if (
				this.item.userId !== this.user.id && !this.isTaskOverdue(this.item)
				&& this.context.item?.preset === PRESETS.MY
			) c.push("--weak");
			//else if (this.item.prio) c.push("--bg-prio");
			//else if (this.item.color) c.push("--bg-" + this.item.color.substr(2));

			if (this.isRouteSomeTask && this.item.id === this.page.task.item?.id && !this.$store.state.ui.pending.taskId && !this.hasChildren) c.push("--current");
			/*if (this.isMD) {
				if (this.item.color) c.push("--bg-" + this.item.color.substr(2));
			}*/
			/*if (this.item.deadline) {
				const {color} = deadlineTextAndCss(this.item);
				c.push("--bell");
			}*/
			if (this.item.bellTill) c.push("--bell");
			if (this.willSetDelayAtTouchEndEvent || this.willSetDoneAtTouchEndEvent) c.push("--slided");
			/*
			else if (this.item.delayedTill || this.item.isDelayed) c.push("--backlog");
			else if (this.index >= Config.TODOS_MAX_MAIN) c.push("--backlog");*/
			return c;
		},
		slideClass() {
			const c = [];
			c.push("--border-accent");
			if (this.item.color) {
				c.push(this.item.color);
			}
			return c;
		},
		slideStyle() {
			const s = [];
			if (this.slidedX) s.push({transform: "translateX(" + this.slidedX + "px)"});
			return s;
		},
		delayedTill() {
			return mysql2DDMMYYYY(this.item.delayedTill)?.substring(0, 5);
		},
		delayedTillFull() {
			return mysql2DDMMYYYY(this.item.delayedTill);
		},
		repeatTitle() {
			let repeatDays = this.item.repeatDays;
			//console.log("type of repeatDays", this.item.auth, this.item.repeatDays, typeof repeatDays === "string");
			if (typeof repeatDays === "string") {
				try {
					repeatDays = JSON.parse(repeatDays);
				} catch (e) {
				}
			}
			//else if (!repeatDays) repeatDays = [false, false, false, false, false, false, false];

			let repeatText = "";
			if (this.item.repeat === "hourly") {
				repeatText = "ежечасно";
			} else if (this.item.repeat === "daily") {
				repeatText = "ежедневно";
			} else if (repeatDays) {
				if (this.item.repeat === "weekly") {
					repeatText = "в дни недели: " + Config.DAY_LABELS.filter((el, index) => repeatDays.includes(index)).join(", ");
				} else if (this.item.repeat === "monthly") {
					repeatText = "ежемесячно по числам: " + repeatDays.map(el => el + 1).join(", ");
				} else if (this.item.repeat === "yearly") {
					repeatText = "ежегодно" + end(repeatDays.length, "", " в такие дни", " в такие дни") + ": " + repeatDays.map(el => iso2DDMMYYYY(el).substring(0, 5)).join(", ");
				}
			}
			return repeatText ? "Задача повторяется " + repeatText : "Это шаблон";
		},
		repeatText() {
			let repeatDays = this.item.repeatDays;
			//console.log("type of repeatDays", this.item.auth, this.item.repeatDays, typeof repeatDays === "string");
			if (typeof repeatDays === "string") {
				try {
					repeatDays = JSON.parse(repeatDays);
				} catch (e) {
				}
			}
			//else if (!repeatDays) repeatDays = [false, false, false, false, false, false, false];

			//console.log("repeat", this.item.repeat);
			let repeatText = "";
			if (this.item.repeat === "hourly") {
				repeatText = "ежечасно";
			} else if (this.item.repeat === "daily") {
				repeatText = "ежедневно";
			} else if (repeatDays) {
				if (this.item.repeat === "weekly") {
					repeatText = Config.DAY_LABELS.filter((el, index) => repeatDays.includes(index)).join(", ");
				} else if (this.item.repeat === "monthly") {
					repeatText = repeatDays.map(el => el + 1).join(", ");
				} else if (this.item.repeat === "yearly") {
					repeatText = maxWords(repeatDays.map(el => iso2DDMMYYYY(el).substring(0, 5)).join(", "), 3);
				}
			}
			return repeatText;
		},
		nameHtml() {
			return this.item.name;
		},
		contentHtml() {
			if (this.compact) return null;
			if (false && this.withGroupName && this.groupOfItem) {
				return this.groupOfItem.name + (this.topicOfItem ? " / " + this.topicOfItem.name : "");
			} else if (false && this.withTopicName && this.topicOfItem) {
				return this.topicOfItem.name;
			} else {
				// todo allow only a hrefs
				const ps = findPs(this.item.name).slice(1).map(line => striptags(line)).join(" ");
				let words = ps.split(" ").map(el => clearName(el.trim())).filter(el => !!el);
				const cut = words.slice(0, 20);
				return cut.join(" ") + (cut?.length < words.length ? "... " : "");
			}
		},
		image() {
			if (!this.item?.name) return null;
			const tags = this.item.name.match(/<img [^>]*data-src-thumb="[^"]*"[^>]*>/gm);
			const thumbs = tags?.map(x => x.replace(/.*data-src-thumb="([^"]*)".*/, '$1'));
			const lazys = tags?.map(x => x.replace(/.*data-src-lazy="([^"]*)".*/, '$1'));
			//console.log(this.item.id + "TAGS", tags);
			if (thumbs?.length) return {
				srcThumb: thumbs[0],
				srcLazy: lazys[0],
			};
			return null;
		},
		parentContext() {
			if (!this.item.topicId) return null;
			return this.topicById(this.item.topicId);
		},
		progress() {
			return countContextInactiveTasks(this.parentContext) * 100 / this.totalChildren;
		},
		progressTitle() {
			return "Прогресс " + countContextInactiveTasks(this.parentContext) + " из " + this.totalChildren + " (" + this.progress.toFixed(0) + "%)";
		},
		progressIcon() {
			//return this.isOpen ? "mdi-chevron-down" : "mdi-plus";
			return this.isOpen ? "mdi-chevron-down" : "mdi-chevron-right";
			/*if (this.countActiveItems === 0) return "mdi-checkbox-multiple-outline";
			if (this.countActiveItems > 9) return "mdi-numeric-9-plus-box-multiple-outline";
			return "mdi-numeric-" + this.countActiveItems + "-box-multiple-outline";*/
		},
		hasChildren() {
			return this.totalChildren > 1;
		},
		totalChildren() {
			return this.children?.length;
		},
		children() {
			return tasksOfContext(this.item);
		},
		childrenText() {
			return this.totalChildren + " " + end(this.totalChildren, "подзадача", "подзадачи", "подзадач");
		}
	},
	methods: {
		onToggleChildren() {
			this.isOpen = !this.isOpen;
		},
		onClickTemplate() {
			this.$store.dispatch("task/dialogTemplate", {
				item: this.item,
			});
		},
		onClickDelayed() {
			/*this.$store.dispatch("task/dialogDelay", {
				item: this.item,
			});*/
		},
		onTouchStart(event) {
			console.log("onTouchStart", event);

			if (this.isMD) return;
			if (this.isAnon) return;

			this.touchStartEvent = event;
			this.willSetDoneAtTouchEndEvent = null;
			this.willSetDelayAtTouchEndEvent = null;
		},
		onTouchMove(event) {
			if (this.willSetDoneAtTouchEndEvent) return;
			if (this.isMD) return;
			if (this.isAnon) return;

			const startX = this.touchStartEvent.changedTouches[0].screenX;
			const startY = this.touchStartEvent.changedTouches[0].screenY;
			const x = event.changedTouches[0].screenX;
			const y = event.changedTouches[0].screenY;
			if (Math.abs(x - startX) > Math.abs(y - startY)) {
				if (x > startX + SLIDE_THRESHOLD) {
					if (x <= startX + SLIDE_DONE) {
						this.slidedX = x - startX;
					}
					if (x >= startX + SLIDE_DONE) {
						this.slidedX = SLIDE_DONE;
						this.timeOfSlideAction = new Date();
						this.willSetDoneAtTouchEndEvent = event;
						this.willBeUndone = this.isTaskDone(this.item);
					}
				} else if (x < startX - SLIDE_THRESHOLD) {
					if (x >= startX - SLIDE_DONE) {
						this.slidedX = x - startX;
					}
					if (x <= startX - SLIDE_DONE) {
						this.slidedX = -SLIDE_DONE;
						this.timeOfSlideAction = new Date();
						this.willSetDelayAtTouchEndEvent = event;
					}
				}
			}
		},
		onTouchEnd(event) {
			console.log("onTouchEnd", event);
			if (this.isMD) return;
			if (this.isAnon) return;

			if (this.willSetDoneAtTouchEndEvent) {
				const now = new Date();
				if (this.timeOfSlideAction) {
					if (this.timeOfSlideAction.valueOf() + SLIDE_ACTION_CONFIRMATION_TIME < now.valueOf()) {
						this.toggleTaskDone(this.item);
					}
				}
				this.willSetDoneAtTouchEndEvent = null;

			} else if (this.willSetDelayAtTouchEndEvent) {
				const now = new Date();
				if (this.timeOfSlideAction) {
					if (this.timeOfSlideAction.valueOf() + SLIDE_ACTION_CONFIRMATION_TIME < now.valueOf()) {
						this.showDialogTaskDelay(this.item);
					}
				}
				this.willSetDelayAtTouchEndEvent = null;
			}

			this.touchStartEvent = null;
			this.slidedX = 0;
			this.timeOfSlideAction = null;
		},
		onMouseDownOnItem(event) {
			if (this.hasChildren) {
				return;
			}

			//console.log("onMouseDownOnItem", event, this.item.name);
			//this.commit("uiSetPendingTask", this.item);
			let eventName = "select";
			let withPrevent = false;

			if (event?.ctrlKey || event?.metaKey) {
				eventName = "select-ctrl";
				withPrevent = true;
			} else if (event?.shiftKey) {
				eventName = "select-shift";
				withPrevent = true;
			} else if (this.isSelected) {
				eventName = null;
				//withPrevent = true;
			}
			if (withPrevent) {
				event.preventDefault();
				event.stopPropagation();
			}
			if (eventName) {
				this.$emit(eventName, this.item, event);
			}
		},
		onClickItem(event) {
			if (this.hasChildren) {
				this.onToggleChildren();
				return;
			}

			//console.log("onClickItem", this.item.name);

			let withPrevent = false;

			if (event?.ctrlKey || event?.metaKey) {
				withPrevent = true;
			} else if (event?.shiftKey) {
				withPrevent = true;
			}
			if (withPrevent) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
		styleOfTag(tag) {
			if (!tag.color) return null;
			const s = {};
			const color = this.colorByCss(tag.color);
			s.backgroundColor = color.color;
			s.color = color.fg;
			return s;
		}
	},
	mounted() {
		if (this.hasChildren && this.isRouteSomeTask && !this.$store.state.ui.pending.taskId) {
			if (this.children?.find(el => el.id === this.page.task.item?.id)) this.isOpen = true;
		}
	}
}
</script>

<style lang="scss">
.context-topic {
	position: relative;
	z-index: 1;

	&__item {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		@include transition();

		@include up($md) {
			//border: 1px solid transparent; // map-get($grey, "lighten-3");//$color-gray;
			//border-radius: 5px;

			&:hover:not(.--readonly) {
				.icon.--check {
					opacity: 1;
				}

				.context-topic__index {
					opacity: 0 !important;
				}
			}
			&:hover:not(.--done):not(.--current) {

				z-index: 1;
				background: map-get($grey, "lighten-5");
				box-shadow: 0 0 15px map-get($grey, "lighten-3");

				.context-topic__name, .context-topic__content, .assignee {
					opacity: 1 !important;
				}

				.context-topic__name {
					color: $black !important;
				}

				&:not(.--readonly) {
					.context-topic__index {
						opacity: 0;
					}
				}

				.btn-prio {
					opacity: 1 !important;
				}
			}
		}

		&.--compact {
			height: 2.8em;

			.context-topic__icon {
				width: 28px;
				height: 28px;
				flex-shrink: 0;
				margin: 0 0.25rem 0 0;
			}

			.context-topic__line {
				gap: 0.5rem;
				padding-right: 0.25rem;
				padding-left: 0.25rem;
			}

			.context-topic__link {
				max-width: calc(100% - 2.25em);
				padding: 0;
				//max-width: 80%;
				.v-chip {
					padding: 0 8px;
				}
			}

			.context-topic__thumb {
				width: 48px;
				height: 30px;
				margin-right: .5rem;
			}
		}

		&:not(.--current):not(.--ignore-inactivity).--weak, &.--done {

			/*.context-topic__name {
				text-decoration: line-through;
				text-decoration-color: $default-text-color; // важно, так как vuetify выставляет прозрачность на text-decoration
			}*/
			.context-topic__name, .context-topic__content, .assignee, {
				opacity: $opacity-done;
			}

			.context-topic__index {
				opacity: $opacity-done;
			}

			.context-topic__thumb {
				opacity: $opacity-done;

				.v-image__image {
					filter: saturate(0);
				}
			}

			.btn-prio {
				opacity: $opacity-done;
			}

			/*.context-topic__delayed {
				opacity: $opacity-done;
			}*/
		}

		&.--done {
			.context-topic__name {
				text-decoration: line-through;
				text-decoration-color: $default-text-color; // важно, так как vuetify выставляет прозрачность на text-decoration
			}

			.__tag {
				opacity: $opacity-done;
			}
		}

		/*&.--prio {

		}*/

		&.--current {
			//@extend .bg--selected;
			.context-topic__name {
				//font-weight: bold;
				color: black;
			}

			/*.context-topic__line {
				background: white;
				@include up($md) {
					background: unset;
				}
			}*/

			@include up($md) {
				z-index: 2;
				background: white;
				box-shadow: 0 0 15px map-get($grey, "lighten-2");
			}
		}

		&.--selected {
			background: white !important;
		}

		&.--slided {
			.context-topic__swiped-tools {
				.v-icon {
					opacity: 1;
				}
			}
		}
	}

	&__slide {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		padding: 0.35rem 0 0.35rem .5rem;
		background: white;
		@include up($md) {
			background: unset;
			padding: 0.35rem 0;
		}

		&-content {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
		}
	}

	&__checker {
		position: relative;
		width: 56px;
		height: 100%;
		flex-shrink: 0;
		//margin: 0 0.25rem 0 0.75rem;
		//display: none;
		display: flex;
		justify-content: center;
		align-items: center;

		.icon.--check {
			opacity: 0;
		}
	}

	&__index {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: none;
		@include transition();

		@include up($md) {
			display: block;
		}
	}

	&__line {
		position: relative;
		//width: calc(100% - 2em);
		//width: calc(100% - 62px);
		flex: 1;
		height: 100%;
		flex-shrink: 0;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding-left: .5rem; //$general-padding;
		padding-right: .5rem; //$general-padding;
		cursor: pointer;
		//background: map-get($grey, "lighten-5");
		//transition: background-color 1.2s ease-in-out;

		@include up($md) {
			gap: 1rem;
			padding-left: 1rem; //$general-padding;
			padding-right: 0; //$general-padding;
			//padding-right: 1rem; //$general-padding;
			background: unset; //map-get($grey, "lighten-5");
		}
	}

	&__link {
		position: relative;
		z-index: 1;
		flex-grow: 1; // on mobile the whole line = link
		color: $default-text-color !important;
		//width: 10%;
		//max-width: calc(100% - 5rem);
		//height: 100%;
		//@include transition();

		/*@include up($md) {
			min-width: 3rem;
			flex-grow: 0; // on desktop the link is only the text part
			//padding: 0.25rem 0 0.25rem 0;
		}*/

		/*&:hover {
			color: $black !important;
			opacity: 1 !important;
		}*/
	}

	&__selector {
		width: 100%;
		height: 100%;
		padding: 0.3rem 0 0.3rem 0;
		display: inline-flex;
		align-items: center;
	}

	&__name {
		//font-weight: 100;
		i {
			opacity: $default-icon-opacity;
			font-weight: normal !important;
		}

		@include transition();
	}

	.assignee {
		@include transition();
	}

	.__tag {
		background: map-get($grey, "lighten-3");
		border-radius: 5px;
		padding: 2px 4px;
		color: $default-text-color;
		font-size: $font-size-5;
	}

	&__tools {
		/*position: absolute;
		z-index: 1;
		top: 16px;
		right: 8px;*/
		//min-width: 15%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-shrink: 0;

		@include up($md) {
			gap: .5em;
		}
	}

	&__thumb {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 64px;
		height: 40px;
		border: 1px solid map-get($grey, "lighten-2");
		margin-right: .75rem;
		overflow: hidden;
		flex-shrink: 0;

		.v-image {
			width: 100%;
			height: 100%;
		}

		/*img {
			display: block;
			//max-width: 100%;
			max-height: 40px;
			object-fit: cover;
			margin: 0;
		}*/
	}

	&__swiped-tools {
		&.--left {
			position: absolute;
			left: 0;
			top: 0;
			width: 60px;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background: map-get($grey, "darken-1");
		}

		&.--right {
			position: absolute;
			right: 0;
			top: 0;
			width: 60px;
			height: 100%;
			//margin: 0 0.25rem 0 0.75rem;
			//display: none;
			display: flex;
			justify-content: center;
			align-items: center;
			background: map-get($blue, "darken-1");
		}

		.v-icon {
			opacity: .4;
		}
	}

	&__progress {
		padding-left: calc(56px + 32px);
		width: 30vw;
		display: flex;
		align-items: center;
		gap: 0.25rem;
		cursor: pointer;

		@include up($md) {
			width: 20vw;

			padding-left: calc(56px + 32px + 1rem);
		}
	}

	&__children {
		padding: .5rem 0 .5rem calc(56px + 32px);
		@include up($md) {
			padding-left: calc(56px + 32px + 1rem);
		}
	}
}
</style>